import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const RootRedirect = () => {
  const { currentUser } = useAuth();

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  switch (currentUser.role) {
    case 'superadmin':
      return <Navigate to="/super-admin/dashboard" replace />;
    case 'admin':
      return <Navigate to="/admin/dashboard" replace />;
    case 'user':
      return <Navigate to="/user/dashboard" replace />;
      case 'auditor': 
      return <Navigate to="/auditor/dashboard" replace />;
    default:
      return <Navigate to="/login" replace />;
  }
};

export default RootRedirect;